module.exports = __webpack_public_path__ + "assets/img/gas.8775c5c7.svg";